// @flow

import React, { type Node } from 'react';
import styled, { css } from 'styled-components';
import { useScreenWidth } from '@tectonics/hooks';
import { DeviceProvider } from './device';

type Props = {|
  mainContent: Node,
  displayContent: Node,
  footerContent: Node,
|};

export function Template(props: Props): Node {
  const screenWidth = useScreenWidth();

  if (screenWidth >= 990) {
    return <DesktopTemplate {...props} />;
  } else {
    return <MobileTemplate {...props} />;
  }
}


function MobileTemplate({ mainContent, displayContent, footerContent }: Props): Node {
  return (
    <DeviceProvider device={'mobile'}>
      <Base>
        <DisplayArea>
          {displayContent}
        </DisplayArea>

        <MainArea>
          {mainContent}
        </MainArea>

        <FooterArea>
          {footerContent}
        </FooterArea>
      </Base>
    </DeviceProvider>
  );
}

function DesktopTemplate({ mainContent, displayContent, footerContent }: Props): Node {
  return (
    <DeviceProvider device={'desktop'}>
      <Base desktop>
        <MainArea desktop>
          <MainAreaContentWrapper>
            {mainContent}
          </MainAreaContentWrapper>
        </MainArea>

        <DisplayArea desktop>
          {displayContent}
          <FooterArea>
            {footerContent}
          </FooterArea>
        </DisplayArea>
      </Base>
    </DeviceProvider>
  );
}

const Base = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 560px;
  margin: 0 auto;

  ${props => props.desktop && css`
    flex-direction: row;
    max-width: none;
  `}
`;

const MainArea = styled.div`
  flex-grow: 1;
  padding: 16px;
  
  ${props => props.desktop && css`
    flex-grow: 11;
    display: flex;
    justify-content: flex-end;
    flex-basis: 0;
    padding: 0;
  `}
`;

const DisplayArea = styled.div`
  ${props => props.desktop && css`
    background: #fafafa;
    flex-grow: 9;
    flex-basis: 0;
    border-left: 1px solid rgb(221, 221, 221);
  `}
`;

const FooterArea = styled.div``;

const MainAreaContentWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-flow: column;
  align-items: flex-end;
  padding: 10vh 4vw;

  & > * {
    width: 100%;
    max-width: 570px;
  }
`;
